import { FormLabel } from "../TriggerEditor/FormLabel";
import { Button, message } from "antd";
import { useForm } from "react-hook-form";
import { getSupaClient, getWorkspace } from "../../lib/supabase";
import { Input } from "../TriggerEditor/Input";

export async function updateWorkspace(workspaceId: string) {
  const supabaseClient = getSupaClient();
  const session = supabaseClient.auth.session();
  const { error } = await supabaseClient.auth.api.updateUserById(
    session?.user?.id!,
    {
      app_metadata: {
        workspace: workspaceId,
      },
    }
  );
  if (error) {
    console.log("Error updating workspace: ", error);
    return false;
  } else {
    await supabaseClient.auth.refreshSession();
    localStorage.removeItem("team-id");
    localStorage.removeItem("guild-id");
    localStorage.removeItem("teams");
    localStorage.removeItem("approved");
    window.location.reload();
    return true;
  }
}

export default function Admin() {
  const supabaseClient = getSupaClient();
  const workspaceId = getWorkspace(supabaseClient);
  const { handleSubmit, register } = useForm({
    defaultValues: { workspaceId },
  });
  const [messageApi, contextHolder] = message.useMessage();

  const onSubmit = async (data: any) => {
    console.log("Changing workspace to", data.workspaceId);
    const success = await updateWorkspace(data.workspaceId);
    if (!success) {
      message.error("error changing workspace");
    }
  };

  return (
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <FormLabel label="Workspace ID">
        <Input
          type="text"
          style={{ width: "100%" }}
          {...register("workspaceId")}
        />
      </FormLabel>
      <Button type="primary" htmlType="submit">
        <div className="flex gap-4 justify-center w-full">
          <span>Change workspace</span>
        </div>
      </Button>
    </form>
  );
}
